import { initAllBanners } from "components/jiffy/promotion-banner/promotion-banner";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllBanners);
} else {
  initAllBanners();
}
